<p-fieldset legend="Main Menu" [toggleable]="true">
    <div class="card">
      <p-toast></p-toast>
      <p-orderList 
        [value]="menuItems" 
        [(selection)]="selectedItems" 
        [dragdrop]="true" 
        (onReorder)="onReorderMainMenu(menuItems)">
        <ng-template let-item let-i="index" pTemplate="item">
        <ng-container *ngIf="!item.separator; else separatorTemplate">
          <div class="menu-item">
            <!-- Main menu item header -->
            <div class="p-d-flex p-ai-center p-jc-between w-full">
              <div class="p-d-flex p-ai-center cursor-pointer" (click)="item.expanded = !item.expanded">
                <i class="pi" [ngClass]="item.expanded ? 'pi-chevron-down' : 'pi-chevron-right'" style="margin-right: 8px;"></i>
                <span>{{ item.label }}</span>
              </div>
              <div class="p-d-flex p-ai-center">
                <button pButton icon="pi pi-pencil"
                        class="p-button-text p-button-rounded"
                        (click)="openEditSectionModal(i)"
                        pTooltip="Edit section">
                </button>
                <button pButton icon="pi pi-trash"
                        class="p-button-text p-button-rounded p-button-danger"
                        (click)="removeMainMenuItem(i)"
                        pTooltip="Remove section">
                </button>
              </div>
            </div>

            <!-- Submenu items -->
            <div *ngIf="item.expanded && item.items" class="submenu-items">
              <div *ngFor="let submenu of item.items" class="submenu-item">
              <ng-container *ngIf="!submenu.separator; else separatorTemplate">
                <div class="p-d-flex p-ai-center p-jc-between">
                  <div class="p-d-flex p-ai-center cursor-pointer" (click)="submenu.expanded = !submenu.expanded">
                    <i class="pi" [ngClass]="submenu.expanded ? 'pi-chevron-down' : 'pi-chevron-right'" style="margin-right: 8px;"></i>
                    <span>{{ submenu.label }}</span>
                  </div>
                  <button pButton icon="pi pi-pencil" 
                          class="p-button-text p-button-rounded" 
                          (click)="openEditSectionModal(i)"
                          pTooltip="Edit section">
                  </button>
                </div>

                <!-- URL or nested items -->
                <div *ngIf="submenu.expanded" class="nested-submenu">
                  <div *ngIf="submenu.url" class="url-display">
                    <i class="pi pi-link" style="margin-right: 8px;"></i>
                    <span class="url-text">{{ submenu.url }}</span>
                  </div>
                  <div *ngIf="submenu.items && submenu.items.length > 0">
                    <div *ngFor="let nestedItem of submenu.items" 
                         class="p-d-flex p-ai-center p-jc-between">
                      <div class="p-d-flex p-ai-center">
                        <i class="pi pi-angle-right" style="margin-right: 8px;"></i>
                        <span>{{ nestedItem.label }}</span>
                      </div>
                      <button pButton icon="pi pi-pencil" 
                              class="p-button-text p-button-rounded" 
                              (click)="openEditSectionModal(i)"
                              pTooltip="Edit section">
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #separatorTemplate></ng-template>
        </ng-template>
      </p-orderList>            
        <div class="buttons-container">
          <p-button label="Add Section" icon="pi pi-plus" class="p-button-outlined"
                    (click)="openAddSectionModal('main')"></p-button>
          <button pButton pRipple label="Save" icon="pi pi-save" 
                  class="p-button-success"
                  (click)="saveMenuOrder('main')"></button>
        </div>

    </div>
  </p-fieldset>
  <p-fieldset legend="Side Menu" [toggleable]="true">
    <div class="card">
      <p-toast></p-toast>
      <p-orderList 
        [value]="sideMenuItems" 
        [(selection)]="selectedItems" 
        [dragdrop]="true" 
        (onReorder)="onReorderSideMenu($event.items)">
        <ng-template let-item let-i="index" pTemplate="item">
          <div class="menu-item">
            <!-- Regular menu item -->
            <ng-container *ngIf="item.type !== 'collapsible'; else collapsibleTemplate">
            <div class="p-d-flex p-ai-center p-jc-between w-full">
              <div class="p-d-flex p-ai-center cursor-pointer">
                <i class="pi" [ngClass]="item.expanded ? 'pi-chevron-down' : 'pi-chevron-right'" style="margin-right: 8px;"></i>
                <span>{{ item.label }}</span>
              </div>
              <div class="p-d-flex p-ai-center">
                <button pButton icon="pi pi-pencil"
                        class="p-button-text p-button-rounded"
                        (click)="openEditSideMenuItemModal(item)"
                        pTooltip="Edit item">
                </button>
                <button pButton icon="pi pi-trash"
                        class="p-button-text p-button-rounded p-button-danger"
                        (click)="removeSideMenuItem(i)"
                        pTooltip="Remove item">
                </button>
              </div>
            </div>

            <!-- Show URL if expanded -->
            <div *ngIf="item.expanded && item.route" class="url-display">
              <i class="pi pi-link" style="margin-right: 8px;"></i>
              <span class="url-text">{{ item.route }}</span>
            </div>
          </ng-container>

          <ng-template #collapsibleTemplate>
            <div class="collapsible-menu">
              <div class="p-d-flex p-ai-center p-jc-between w-full">
                <div class="p-d-flex p-ai-center cursor-pointer" (click)="item.expanded = !item.expanded">
                  <i class="pi" [ngClass]="item.expanded ? 'pi-chevron-down' : 'pi-chevron-right'" style="margin-right: 8px;"></i>
                  <span>{{ item.label }}</span>
                </div>
                <div class="p-d-flex p-ai-center">
                  <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded" (click)="openEditSideMenuItemModal(item)" pTooltip="Edit item"></button>
                  <button pButton icon="pi pi-trash" class="p-button-text p-button-rounded p-button-danger" (click)="removeSideMenuItem(i)" pTooltip="Remove item"></button>
                </div>
              </div>
              <div *ngIf="item.expanded" class="submenu-items">
                <div *ngFor="let subItem of item.subMenu" class="submenu-item">
                  <div class="p-d-flex p-ai-center p-jc-between">
                    <div class="p-d-flex p-ai-center cursor-pointer">
                      <i class="pi pi-angle-right" style="margin-right: 8px;"></i>
                      <span>{{ subItem.label }}</span>
                    </div>
                    <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded" (click)="openEditSideMenuItemModal(item)" pTooltip="Edit parent item"></button>
                  </div>
                  <div *ngIf="subItem.route" class="url-display">
                    <i class="pi pi-link" style="margin-right: 8px;"></i>
                    <span class="url-text">{{ subItem.route }}</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          </div>
        </ng-template>
      </p-orderList>            
      <div class="buttons-container">
        <p-button label="Add Item" icon="pi pi-plus" class="p-button-outlined"
                  (click)="openAddSideMenuItemModal()"></p-button>
        <button pButton pRipple label="Save" icon="pi pi-save"
                class="p-button-success"
                (click)="saveMenuOrder('side')"></button>
      </div>

  <p-confirmDialog></p-confirmDialog>

  <!-- Main Menu: Add/Edit Section dialog -->
  <p-dialog [(visible)]="isAddSectionModalOpen" [header]="sectionModalTitle" [style]="{width: '60vw'}" [modal]="true" (onHide)="closeAddSectionModal()">
    <form #sectionFormRef="ngForm" class="section-form">
      <div class="p-field p-mb-3">
        <label for="sectionLabel">Section Name <span class="required">*</span></label>
        <input id="sectionLabel" type="text" pInputText class="p-inputtext w-full" [(ngModel)]="sectionForm.label" name="sectionLabel" required placeholder="e.g. Mystery Box" />
      </div>

      <div class="form-section">
        <div class="p-d-flex p-ai-center p-jc-between p-mb-2">
          <label class="p-mb-0">Items</label>
          <button pButton type="button" label="Add Item" icon="pi pi-plus" class="p-button-outlined p-button-sm" (click)="addFormItem()"></button>
        </div>

        <div *ngFor="let item of sectionForm.items; let i = index" class="form-item-block p-mb-3">
          <div class="form-item-header p-p-2 p-mb-2">
            <span class="form-item-title">Item {{ i + 1 }}</span>
            <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-rounded p-button-danger p-button-sm" (click)="removeFormItem(i)" pTooltip="Remove item"></button>
          </div>
          <div class="p-grid p-fluid p-mb-2">
            <div class="p-col-6">
              <label for="itemLabel{{i}}">Label <span class="required">*</span></label>
              <input id="itemLabel{{i}}" type="text" pInputText class="p-inputtext w-full" [(ngModel)]="item.label" [name]="'itemLabel' + i" required placeholder="Item name" />
            </div>
            <div class="p-col-6">
              <label for="itemUrl{{i}}">URL</label>
              <input id="itemUrl{{i}}" type="text" pInputText class="p-inputtext w-full" [(ngModel)]="item.url" [name]="'itemUrl' + i" placeholder="/route-path" />
            </div>
          </div>
          <div class="p-grid p-fluid p-mb-2">
            <div class="p-col-6">
              <label for="itemIcon{{i}}">Icon (optional)</label>
              <input id="itemIcon{{i}}" type="text" pInputText class="p-inputtext w-full" [(ngModel)]="item.icon" [name]="'itemIcon' + i" placeholder="pi pi-fw pi-home" />
            </div>
          </div>

          <div class="sub-items-wrap p-ml-3 p-mb-2">
            <div class="p-d-flex p-ai-center p-jc-between p-mb-2">
              <label class="p-mb-0">Sub-items</label>
              <button pButton type="button" label="Add Sub-Item" icon="pi pi-plus" class="p-button-outlined p-button-sm" (click)="addFormSubItem(i)"></button>
            </div>
            <div *ngFor="let sub of item.subItems; let j = index" class="form-sub-item p-p-2 p-mb-2">
              <div class="p-grid p-fluid">
                <div class="p-col-5">
                  <label [for]="'subLabel' + i + '_' + j">Label <span class="required">*</span></label>
                  <input [id]="'subLabel' + i + '_' + j" type="text" pInputText class="p-inputtext w-full" [(ngModel)]="sub.label" [name]="'subLabel' + i + '_' + j" required placeholder="e.g. New" />
                </div>
                <div class="p-col-5">
                  <label [for]="'subUrl' + i + '_' + j">URL <span class="required">*</span></label>
                  <input [id]="'subUrl' + i + '_' + j" type="text" pInputText class="p-inputtext w-full" [(ngModel)]="sub.url" [name]="'subUrl' + i + '_' + j" required placeholder="/route-path/add" />
                </div>
                <div class="p-col-2 p-d-flex p-ai-end">
                  <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-rounded p-button-danger p-button-sm" (click)="removeFormSubItem(i, j)" pTooltip="Remove sub-item"></button>
                </div>
              </div>
              <div class="p-grid p-fluid p-mt-1">
                <div class="p-col-6">
                  <label [for]="'subIcon' + i + '_' + j">Icon (optional)</label>
                  <input [id]="'subIcon' + i + '_' + j" type="text" pInputText class="p-inputtext w-full" [(ngModel)]="sub.icon" [name]="'subIcon' + i + '_' + j" placeholder="pi pi-fw pi-plus" />
                </div>
                <div class="p-col-6">
                  <label [for]="'subTarget' + i + '_' + j">Target (optional)</label>
                  <input [id]="'subTarget' + i + '_' + j" type="text" pInputText class="p-inputtext w-full" [(ngModel)]="sub.target" [name]="'subTarget' + i + '_' + j" placeholder="_blank" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="p-d-flex p-jc-end p-mt-3">
      <button pButton label="Cancel" class="p-button-text" (click)="closeAddSectionModal()"></button>
      <button pButton [label]="isEditingSection ? 'Save' : 'Add'" icon="pi pi-check" class="p-button-success" (click)="saveSectionForm()"></button>
    </div>
  </p-dialog>

  <!-- Main Menu: JSON editor dialog (view/edit raw JSON for a section) -->
  <p-dialog
    [(visible)]="showJsonDialog"
    [header]="selectedItemLabel"
    [style]="{width: '50vw'}"
    [modal]="true">
    <div class="json-viewer">
      <textarea [(ngModel)]="editableJson" rows="20" style="width: 100%;"></textarea>
    </div>
    <div class="p-d-flex p-jc-end p-mt-3">
      <button pButton label="Save" icon="pi pi-save" class="p-button-secondary p-mr-2" (click)="saveJsonChanges()"></button>
      <button pButton label="Copy" icon="pi pi-copy" class="p-button-secondary p-mr-2" (click)="copyJsonToClipboard()"></button>
      <button pButton label="Close" class="p-button-secondary" (click)="showJsonDialog = false"></button>
    </div>
  </p-dialog>

  <!-- Side Menu: Add/Edit item form dialog -->
  <p-dialog
    [(visible)]="isAddSideMenuItemModalOpen"
    [header]="editingSideMenuItemIndex !== null ? 'Edit Side Menu Item' : 'Add Side Menu Item'"
    [style]="{width: '55vw'}"
    [modal]="true"
    (onHide)="closeSideMenuItemModal()">
    <form #sideMenuItemFormRef="ngForm" class="section-form">

      <div class="p-grid p-fluid p-mb-3">
        <div class="p-col-6">
          <label for="sideLabel">Label <span class="required">*</span></label>
          <input id="sideLabel" type="text" pInputText class="p-inputtext w-full"
                 [(ngModel)]="sideMenuItemForm.label" name="sideLabel" required placeholder="e.g. Home" />
        </div>
        <div class="p-col-6">
          <label for="sideType">Type <span class="required">*</span></label>
          <p-dropdown id="sideType"
            [options]="[{label: 'Single', value: 'single'}, {label: 'Collapsible', value: 'collapsible'}]"
            [(ngModel)]="sideMenuItemForm.type"
            name="sideType"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full">
          </p-dropdown>
        </div>
      </div>

      <div class="p-grid p-fluid p-mb-3">
        <div class="p-col-6">
          <label for="sidePermission">Permission (optional)</label>
          <input id="sidePermission" type="text" pInputText class="p-inputtext w-full"
                 [(ngModel)]="sideMenuItemForm.permission" name="sidePermission" placeholder="e.g. items.view" />
        </div>
        <div class="p-col-6 p-d-flex p-ai-center p-mt-3">
          <p-checkbox [(ngModel)]="sideMenuItemForm.visible" [binary]="true" name="sideVisible" inputId="sideVisible"></p-checkbox>
          <label for="sideVisible" class="p-ml-2">Visible</label>
        </div>
      </div>

      <!-- Single item fields -->
      <ng-container *ngIf="sideMenuItemForm.type === 'single'">
        <div class="p-grid p-fluid p-mb-3">
          <div class="p-col-4">
            <label for="sideIcon">Icon (optional)</label>
            <input id="sideIcon" type="text" pInputText class="p-inputtext w-full"
                   [(ngModel)]="sideMenuItemForm.icon" name="sideIcon" placeholder="pi pi-home" />
          </div>
          <div class="p-col-4">
            <label for="sideRoute">Route</label>
            <input id="sideRoute" type="text" pInputText class="p-inputtext w-full"
                   [(ngModel)]="sideMenuItemForm.route" name="sideRoute" placeholder="/route-path"
                   pattern="^$|^\/.*" #sideRouteInput="ngModel" />
            <small *ngIf="sideRouteInput.invalid && sideRouteInput.dirty" class="p-error">
              Route must start with /.
            </small>
          </div>
          <div class="p-col-4">
            <label for="sideAction">Action</label>
            <input id="sideAction" type="text" pInputText class="p-inputtext w-full"
                   [(ngModel)]="sideMenuItemForm.action" name="sideAction" placeholder="e.g. logout" />
          </div>
        </div>
      </ng-container>

      <!-- Collapsible sub-menu items -->
      <ng-container *ngIf="sideMenuItemForm.type === 'collapsible'">
        <div class="form-section">
          <div class="p-d-flex p-ai-center p-jc-between p-mb-2">
            <label class="p-mb-0">Sub-menu Items</label>
            <button pButton type="button" label="Add Sub-Item" icon="pi pi-plus"
                    class="p-button-outlined p-button-sm" (click)="addSubMenuItem()"></button>
          </div>
          <div *ngFor="let sub of sideMenuItemForm.subMenu; let i = index" class="form-item-block p-mb-3">
            <div class="form-item-header p-p-2 p-mb-2">
              <span class="form-item-title">Sub-item {{ i + 1 }}</span>
              <button pButton type="button" icon="pi pi-trash"
                      class="p-button-text p-button-rounded p-button-danger p-button-sm"
                      (click)="removeSubMenuItem(i)" pTooltip="Remove sub-item"></button>
            </div>
            <div class="p-grid p-fluid">
              <div class="p-col-4">
                <label [for]="'subSideLabel' + i">Label <span class="required">*</span></label>
                <input [id]="'subSideLabel' + i" type="text" pInputText class="p-inputtext w-full"
                       [(ngModel)]="sub.label" [name]="'subSideLabel' + i" required placeholder="e.g. All Items" />
              </div>
              <div class="p-col-4">
                <label [for]="'subSideRoute' + i">Route</label>
                <input [id]="'subSideRoute' + i" type="text" pInputText class="p-inputtext w-full"
                       [(ngModel)]="sub.route" [name]="'subSideRoute' + i" placeholder="/route-path"
                       pattern="^$|^\/.*" #subSideRouteInput="ngModel" />
                <small *ngIf="subSideRouteInput.invalid && subSideRouteInput.dirty" class="p-error">
                  Route must start with /.
                </small>
              </div>
              <div class="p-col-4">
                <label [for]="'subSideAction' + i">Action</label>
                <input [id]="'subSideAction' + i" type="text" pInputText class="p-inputtext w-full"
                       [(ngModel)]="sub.action" [name]="'subSideAction' + i" placeholder="e.g. logout" />
              </div>
            </div>
            <div class="p-grid p-fluid p-mt-1">
              <div class="p-col-6">
                <label [for]="'subSidePermission' + i">Permission (optional)</label>
                <input [id]="'subSidePermission' + i" type="text" pInputText class="p-inputtext w-full"
                       [(ngModel)]="sub.permission" [name]="'subSidePermission' + i" placeholder="e.g. items.view" />
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </form>

    <div class="p-d-flex p-jc-end p-mt-3">
      <button pButton label="Cancel" class="p-button-text" (click)="closeSideMenuItemModal()"></button>
      <button pButton [label]="editingSideMenuItemIndex !== null ? 'Save' : 'Add'" icon="pi pi-check"
              class="p-button-success" (click)="saveSideMenuItemForm()"></button>
    </div>
  </p-dialog>
